import JLnbMSelectSCArea from './JLnbMSelectSCArea'

export default {
  JLnbMSelectSCArea
}